import { render } from "./workStart2025.vue?vue&type=template&id=08be160b&scoped=true"
import script from "./workStart2025.vue?vue&type=script&lang=ts"
export * from "./workStart2025.vue?vue&type=script&lang=ts"

import "./workStart2025.vue?vue&type=style&index=0&id=08be160b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08be160b"

export default script